import axios from "../../axios";

const urlForm = "/form-builder";
const urlFormDeleteMultiple = "/form-builder/delete-multiple";

const state = {
  forms: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * getListForms
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListForms({ commit }, query) {
    const response = await axios.get(
      `${urlForm}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_FORMS", response.data.data);
    }

    return response;

    // try {
    //   return new Promise((resolve, reject) => {
    //     axios.get(`${urlForm}?${new URLSearchParams(query)}`)
    //       .then((response) => {
    //         commit('SET_LIST_FORMS', response.data.data)
    //         resolve(response.data ?? {})
    //       })
    //       .catch((error) => { reject(error) })
    //   })
    // } catch (e) {
    //   console.log('exception: ', e)
    // }
  },

  /**
   * createForm
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createForm({ commit }, payload) {
    return await axios.post(urlForm, payload);
  },

  /**
   * updateForm
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateForm({ commit }, { id, payload }) {
    return await axios.put(`${urlForm}/${id}`, payload);
  },

  /**
   * deleteForm
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteForm({ commit }, id) {
    return await axios.delete(`${urlForm}/${id}`);
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlFormDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_FORMS(state, data) {
    if (data) {
      state.forms = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
